module.exports = __webpack_public_path__ + "media/images/products/banners/dividendos-5bd9883b51146afe04bbd4b2583d9340.png";